import { createUrlWithSourceQueryParams } from '@crehana/analytics';
import { Button } from '@crehana/compass.ui/v2';
import { formatDate, formatDuration } from '@crehana/date';
import Link from 'next/link';

import { COURSE_DETAIL_AMPLITUDE_PAGE_NAME } from '../../constants';
import { useCourseDetailCourse, useCourseDetailTranslation } from '../../hooks';
import { LeaderAssignContentButton } from '../leader-assign-content-button';
import GridResume from './ui/GridResume';
import MobileFixedContent from './ui/MobileFixedContent';

export const TransactionButtonsWrapper: React.FC = () => {
  const { t, languageCode } = useCourseDetailTranslation();
  const { course, organizationSlug } = useCourseDetailCourse();

  const formattedUpdatedAt = course.modifiedDate
    ? formatDate(course.modifiedDate, {
        languageCode,
        outputFormat: 'DD/MM/YYYY',
      })
    : undefined;

  return (
    <>
      <GridResume
        duration={formatDuration(course.duration)}
        level={course.level?.name || ''}
        students={course.enrollments}
        updatedAt={formattedUpdatedAt}
        attachments={course.totalAttachments}
        className="sm:tw-mb-1.6"
      />

      <MobileFixedContent>
        <Link
          href={createUrlWithSourceQueryParams({
            url: course.playerUrl,
            source: COURSE_DETAIL_AMPLITUDE_PAGE_NAME,
            sourceDetail: 'Floating Card',
          })}
        >
          <Button
            type="submit"
            size="md"
            variant="primary"
            className="tw-w-full tw-justify-center"
          >
            {t('GO_TO_COURSE')}
          </Button>
        </Link>
        <LeaderAssignContentButton
          className="tw-mt-1.6 tw-hidden md:tw-block"
          courseId={course.originalId}
          organizationSlug={organizationSlug}
        />
      </MobileFixedContent>
    </>
  );
};

export default TransactionButtonsWrapper;
